import { AbstractControl, ValidationErrors } from "@angular/forms";

export function passwordMatchValidator(control:AbstractControl):ValidationErrors|null{
    const password=control.get('newPassword')?.value;
    const confirmPassword=control.get('confirmPassword')?.value;
    return password===confirmPassword? null : { notSame:true };
}
